<div class="action-arrow__content_ci">
    <a (click)="resolveOrder()" [attr.disabled]="actionsDisabled" [pTooltip]="actionTooltips.RESOLVE"
        tooltipStyleClass="custom-sm-tooltip" tooltipPosition="top" class="action-icon action-icon-active">
        <i class="fas fa-gears"></i>
    </a>
    <a (click)="reOpen()" [attr.disabled]="actionsDisabled" [pTooltip]="actionTooltips.REOPEN"
        tooltipStyleClass="custom-sm-tooltip" tooltipPosition="top" [ngClass]="{
        'action-icon': true,
        'action-icon-inactive': !canReopen,
        'action-icon-active': canReopen,
        disabled: actionsDisabled
    }">
        <i class="fas fa-undo"></i>
    </a>
    <ng-container *ngIf="validateOverWriteVisibility(); else cuOverwrite">
        <a [pTooltip]="actionTooltips.OVERWRITE" tooltipStyleClass="custom-sm-tooltip" tooltipPosition="top"
            class="action-icon-active" (click)="openCUDialog()">
            <i class="fa fa-star" [title]="getLockTitle()"> </i>
        </a>
    </ng-container>
    <ng-template #cuOverwrite>
        <span class="icon placeholder" aria-hidden="true"></span>
    </ng-template>

    <a
        [pTooltip]="actionTooltips.RECALL"
        tooltipStyleClass="custom-sm-tooltip"
        tooltipPosition="top"
        (click)="toggleReSubmitBox()"
        [attr.disabled]="actionsDisabled"
        [ngClass]="{
            'action-icon': true,
            'action-icon-inactive': !canResubmit,
            'action-icon-active': canResubmit,
            disabled: actionsDisabled
        }">
        <i class="fas fa-file-upload"></i>
    </a>

    <ng-container *ngIf="cellValue.data.locked; else lockedPlaceHolder">
        <span *ngIf="cellValue.data.locked" class="action-icon locked-by" [pTooltip]="getLockTitle()" tooltipStyleClass="custom-sm-tooltip" tooltipPosition="left">
            <i class="fa fa-lock"> </i>
            <span class="locked-by-information">
                <span class="locked-by">
                    {{ getNameInitials() }}
                </span>
            </span>
        </span>
    </ng-container>
    <ng-template #lockedPlaceHolder>
        <span class="icon placeholder" aria-hidden="true"></span>
    </ng-template>

    <a
        (click)="openOrder()"
        class="action-icon action-icon-active"
        [attr.disabled]="actionsDisabled"
        [pTooltip]="goToOrderMessage"
        tooltipStyleClass="custom-sm-tooltip"
        tooltipPosition="top"
        [ngClass]="{
            disabled: actionsDisabled
        }">
        <i class="fas fa-arrow-right" *ngIf="!loadingOrder"></i>
        <div class="loading-wrapper" *ngIf="loadingOrder">
            <i class="fas fa-spinner"></i>
        </div>
    </a>
</div>
